"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import "./OurRecentWork.css";

import CowDaoLogo from "../../../public/assets/General-Img/Home/CowDaoLogo.webp";
import CowDao from "../../../public/assets/General-Img/Home/CowDao.webp";
import KucoinLogo from "../../../public/assets/General-Img/Home/KucoinLogo.webp";
import Kucoin from "../../../public/assets/General-Img/Home/Kucoin.webp";
import PimlicoLogo from "../../../public/assets/General-Img/Home/PimlicoLogo.webp";
import Pimlico from "../../../public/assets/General-Img/Home/Pimlico.webp";
import AnimatedCount from "@/app/components/ui/common/CountUp/AnimatedCount";

export const OurRecentWork = () => {
    const content = {
        title: "Our Recent Work",
        subtitle: "",
        services: [
            {
                id: 1,
                logo: CowDaoLogo,
                textTitle: "NFT DEVELOPMENT",
                text: "Transform your digital creations into valuable assets. We specialize in crafting unique NFTs that capture attention and drive market success.",
                image: CowDao,
                imageLink:
                    "https://www.tanthetaa.com/portfolio/decentralized-exchange-like-cowswap",
                descriptionNumber: "2500+",
                descriptionText: "",
                subDescription: "Projects Delivered",
                viewMore: "View More -->",
                viewMoreLink: "https://www.tanthetaa.com/portfolio",
                btnName: "",
                btnLink: "",
                subDesColor: "bg-[#FFFFFF]",
                ViewCaseStudyColor: "white",
            },
            {
                id: 2,
                logo: KucoinLogo,
                textTitle: "CRYPTO DEVELOPMENT",
                text: "Build powerful,secure and scalable crypto platforms. From exchanges to wallets,we deliver innovative solutions for the digital currency ecosystem.",
                image: Kucoin,
                imageLink:
                    "https://www.tanthetaa.com/portfolio/mobileapp-like-kucoin",
                descriptionNumber: "1600+",
                descriptionText: "",
                subDescription: "Happy Clients",
                viewMore: "",
                viewMoreLink: "",
                btnName: "",
                btnLink: "",
                subDesColor: "bg-[#FFFFFF]",
                ViewCaseStudyColor: "black",
            },
            {
                id: 3,
                logo: PimlicoLogo,
                textTitle: "BLOCKCHAIN DEVELOPMENT",
                text: "Unlock the potential of blockchain technology. We create custom solutions for decentralized applications,smart contracts and enterprise-grade blockchain.",
                image: Pimlico,
                imageLink: "https://www.tanthetaa.com/portfolio/pimlico",
                descriptionNumber: "",
                descriptionText: "Want to start a Project?",
                subDescription: "",
                viewMore: "",
                viewMoreLink: "",
                btnName: "Get a Free Quote",
                btnLink: "https://www.tanthetaa.com/contact",
                subDesColor: "bg-linear",
                ViewCaseStudyColor: "white",
            },
        ],
    };

    const backgroundStyle = {
        backgroundImage:
            "linear-gradient(98.46deg, #410EAD -1.13%, #7B3FE4 98.96%)",
    };
    const boxShadow = {
        boxShadow: "0px 0px 28px 0px rgba(151, 151, 151, 0.16)",
    };

    return (
        <div className="container mx-auto my-10 lg:my-[110px] px-4 md:px-24 lg:px-24 xl:px-0">
            <h2 className="text-2xl md:text-3xl xl:text-4xl font-bold pb-16 text-center font-manrope">
                {content?.title}
            </h2>
            <div className="grid grid-cols-1 xl:grid-cols-3 md:grid-cols-2 gap-10 justify-center">
                {content?.services?.map((ele, index) => {
                    return (
                        <div key={index} className="flex flex-col">
                            <Link href={ele?.imageLink && ele?.imageLink}>
                                {/* Set the minimum and maximum height for uniform box sizes */}
                                <div className="flex flex-col justify-between bg-[#F8F3FF] rounded-lg imageHover relative overflow-hidden min-h-[550px] max-h-[550px] group">
                                    <div className="flex-grow">
                                        <Image
                                            src={ele?.logo}
                                            alt={ele?.textTitle}
                                            width={100}
                                            height={100}
                                            className="mx-auto py-6 px-5 w-72 h-24 cursor-pointer text-center object-contain"
                                        />
                                        <div className="flex flex-col gap-5 my-3 xl:px-8 lg:px-5 md:px-3 px-2 justify-center text-black items-center">
                                            <span className="text-2xl text-center font-extrabold leading-7">
                                                {ele?.textTitle}
                                            </span>
                                            <p className="text-base text-center font-medium leading-5">
                                                {ele?.text}
                                            </p>
                                        </div>
                                    </div>
                                    <Image
                                        src={ele?.image}
                                        alt={ele?.textTitle}
                                        width={300}
                                        height={250}
                                        className="mx-auto object-contain cursor-pointer text-end md:pl-4 pl-0 pt-9 w-fit h-[300px] absolute bottom-0 right-0"
                                    />

                                    <div className="absolute bottom-4 right-4 bg-[#7338DD] p-4 rounded-full flex items-center justify-center rotate-[140deg]">
                                        <div className="arrow"></div>
                                    </div>
                                </div>
                            </Link>

                            {/* Sub-description Container */}
                            <div
                                className="grid gap-2 place-items-center font-bold py-9 lg:py-12 rounded-xl mt-4 h-44 flex-grow"
                                style={{
                                    ...boxShadow,
                                    background:
                                        ele?.subDesColor === "bg-linear"
                                            ? backgroundStyle.backgroundImage
                                            : "#FFFFFF",
                                }}
                            >
                                {ele?.descriptionNumber &&
                                    typeof window !== "undefined" && (
                                        <span className="text-2xl font-bold md:text-3xl xl:text-4xl">
                                            <AnimatedCount
                                                end={parseInt(
                                                    ele?.descriptionNumber
                                                )}
                                                suffix="+"
                                            />
                                        </span>
                                    )}

                                {ele?.descriptionText && (
                                    <span className="text-lg md:text-xl xl:text-2xl text-white">
                                        {ele?.descriptionText}
                                    </span>
                                )}

                                {ele?.subDescription && (
                                    <span className="text-xl font-semibold leading-6 text-[#323232]">
                                        {ele?.subDescription}
                                    </span>
                                )}

                                {ele?.viewMore && (
                                    <Link
                                        href={
                                            ele?.viewMoreLink &&
                                            ele?.viewMoreLink
                                        }
                                    >
                                        <p className="text-base font-medium leading-4 text-[#410EAD] hover:text-[#0BB226] cursor-pointer">
                                            {ele?.viewMore}
                                        </p>
                                    </Link>
                                )}

                                {ele?.btnName && (
                                    <Link href={ele?.btnLink && ele?.btnLink}>
                                        <button className="text-lg font-semibold leading-5 border border-white text-white rounded-md py-1.5 px-8 bg-transparent hover:bg-[#0BB226] hover:text-black transition delay-150 ease-in-out duration-300">
                                            {ele?.btnName}
                                        </button>
                                    </Link>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OurRecentWork;
